<mat-paginator
    *ngIf="!hidden && totalCount > 0"
    class="app-pagination"
    [length]="safeTotalCount"
    [pageIndex]="pageIndex"
    [pageSize]="safePageSize"
    [pageSizeOptions]="pageSizeOptions"
    [disabled]="disabled"
    [showFirstLastButtons]="showFirstLastButtons"
    [attr.aria-label]="ariaLabel"
    (page)="onPage($event)">
</mat-paginator>
